import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { CONTACT, ASSETS } from "@/lib/contact";

export default function Nav() {
  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-chrome/20 bg-black/85 backdrop-blur-md"
    >
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-5 sm:px-8">
        <a
          href="#top"
          data-testid="nav-logo-link"
          className="flex items-center gap-3"
          aria-label="GORILLAS REBOQUE - Início"
        >
          <img
            src={ASSETS.logo}
            alt="GORILLAS REBOQUE logo"
            className="h-10 w-10 rounded-sm object-cover ring-1 ring-chrome/30"
            loading="eager"
            decoding="async"
          />
          <div className="flex flex-col leading-none">
            <span className="font-display text-lg tracking-widest text-white sm:text-xl">
              GORILLAS
            </span>
            <span className="text-[10px] font-semibold tracking-[0.28em] text-brand-yellow sm:text-xs">
              REBOQUE · 24H
            </span>
          </div>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {[
            ["Serviços", "#servicos"],
            ["Diferenciais", "#diferenciais"],
            ["Avaliações", "#avaliacoes"],
            ["Áreas", "#areas"],
            ["Contato", "#contato"],
          ].map(([label, href]) => (
            <a
              key={href}
              href={href}
              data-testid={`nav-link-${label.toLowerCase()}`}
              className="group relative text-[11px] font-semibold uppercase tracking-[0.3em] text-neutral-300 transition-colors hover:text-brand-yellow"
            >
              {label}
              <span className="absolute -bottom-2 left-0 h-px w-0 bg-brand-yellow transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <a
          href={CONTACT.telHref}
          data-testid="nav-call-btn"
          className="hidden items-center gap-2 border border-transparent bg-brand-yellow px-4 py-2 font-display text-sm tracking-widest text-black transition-all hover:bg-black hover:text-brand-yellow hover:border-brand-yellow sm:inline-flex"
        >
          <Phone className="h-4 w-4" strokeWidth={2.5} />
          LIGAR AGORA
        </a>
      </div>
    </motion.header>
  );
}
